export class FindAllProjectsError {
  public static readonly type =
    '[Organisation/Projects/List] FindAllProjectsError';
  constructor(public readonly error: Error) {}
}
